import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { DoenKidsAuth0Provider } from 'src/providers/auth0.provider';
import { DoenkidsSessionProvider } from 'src/providers/session.provider';
import { CurrentUserService } from 'src/api/customer/auth/auth.service';
import { RedirectProvider } from 'src/providers/redirect.provider';

export const doenKidsAuthGuard = async () => {
  const router = inject(Router);
  const $session = inject(DoenkidsSessionProvider);
  const $auth0Provider = inject(DoenKidsAuth0Provider);
  const currentUserService = inject(CurrentUserService);
  const $redirect = inject(RedirectProvider);

  console.log('[AUTH-GUARD] Waiting for profile...');
  const profile = await $auth0Provider.profile();
  if (profile) {
    console.log('[AUTH-GUARD] Discovered valid session');

    // Ensure user details are fetched from the API at least once
    //
    if (!($session.getCurrentUser())) {
      console.log('[AUTH-GUARD] Fetching current user details');
      await currentUserService.fetch();
    }
    return true;
  }

  console.log('[AUTH-GUARD] redirect to login');
  $redirect.setPathToRedirectTo(document.location.pathname);
  router.navigate(['login']);
  return false;
};
